/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import useDebounce from "../../../utilities/useDebounce";
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import ToggleButton from "../../../components/ToggleButton";
import AddTireModal from "./AddTireModal";
import ViewCitiesModal from "./ViewCitiesModal";
import { useForm } from "react-hook-form";
import {
  useFetchTireData,
  useTireCreateMutation,
  useUpdateTireStatus,
} from "../../../apis/zoneAndTierApis";
import toast from "react-hot-toast";
import formatDate from "../../../utilities/helper";
import MessageModal from "../../../components/MessageModal";

type CoverageFormValues = {
  name: string;
  countryId: string | null;
  warehouseId: string;
  coverageCity: string | null;
};
export default function TireListTab() {
  const [openZone, setOpenZone] = useState<boolean>(false);
  const openZoneToggleModal = () => {
    setOpenZone(!openZone);
  };
  const [searchFor, setSearchFor] = useState<string>("");
  const debouncedSearchFor = useDebounce(searchFor, 550);
  const { mutate, isPending: activePending } = useTireCreateMutation();
  const { data: tireData, refetch: tireRefetch } = useFetchTireData(1, 10, debouncedSearchFor);
  const { mutate: updateTireStatus, isPending: statusPending } =
    useUpdateTireStatus();
  const [tireItem, setTireItem] = useState<any>(null);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const [tireDataArray, setTireDataArray] = useState<any>(tireData);
  const [openEditZone, setOpenEditZone] = useState<boolean>(false);
  const [editable, setOpenEditable] = useState<boolean>(false);
  const [citiesArray, setCitiesArray] = useState<any>();
  const openEditZoneToggleModal = () => {
    setOpenEditZone(!openEditZone);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [coverageCityError, setCoverageCityError] = useState<string>("");
  //  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedWarehouseId, setSelectedWarehouseId] =
    useState<string>("wh123");
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    watch,
    formState: { errors },
    setValue,
    control,
  } = useForm<CoverageFormValues>();

  useEffect(() => {
    if (tireData) {
      setTireDataArray(tireData);
    }
  }, [tireData]);

  const handleToggleStatus = async (tire: any) => {
    const newStatus = tire?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setTireItem(tire);

    setStatus(tire.status);
    setActionModal(true);
  };

  const handleUpdateStatus = async () => {
    const newStatus = tireItem?.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

    // Optimistically update UI (optional: use local state or refetch later)
    const updatedTimeSlot = tireDataArray.tires.map((v: any) =>
      v.id === tireItem?.id ? { ...v, status: newStatus } : v
    );
    await setTireDataArray({ ...tireDataArray, tires: updatedTimeSlot });

    // Send to API (example)
    await updateTireStatus({ id: tireItem?.id, status: newStatus });
    setActionModal(false);
    setTireItem(null);
  };
  const handleAddTire = (data: any) => {
    if (!data?.coverageCity || data?.coverageCity?.length === 0) {
      setCoverageCityError("Please select minimum one city");
      return;
    }
    setCoverageCityError("");
    mutate(
      { ...data },
      {
        onSuccess: (data) => {
          reset();
          tireRefetch();
          setIsModalOpen(false);
          // setMode(null);
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  const handleEyeAction = (item: any) => {
    reset();
    // setTireItem(item);
    setOpenEditable(!editable);
    setIsModalOpen(!isModalOpen);
  };

  const handleViewCities = (cities: any) => {
    setCitiesArray(cities);
    setIsOpen(true);
  };

  return (
    <>
      <div className="rounded-3xl">
        <div className="flex items-start">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
            <h1 className="text-3xl text-[#212121]">Tire List</h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch value={searchFor} onChange={(e) => setSearchFor(e.target.value)} />
            </div>
          </div>
          <div className="relative ml-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              viewBox="0 0 34 34"
              fill="none"
              className="absolute -bottom-[12.5px] -left-[22.5px] rotate-[2deg] "
            >
              <path
                d="M0.5 0.5C4.94768 14.4784 15.2221 25.8511 28.6786 31.6907L34 34H2.31268L0.5 0.5Z"
                fill="#F7F6F2"
              />
            </svg>

            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
              >
                <IconPlus stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {" "}
          <ListView
            data={tireDataArray?.tires ?? []}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "#", render: (_, i) => i + 1 },
              {
                label: "Zone Name",
                render: (c: any) => c.name,
              },
              {
                label: "Warehouse",
                render: (c) => c.warehouseName,
              },
              { label: "Country", render: (c) => c.countryName },
              {
                label: "City",
                render: (c) => (
                  <button
                    onClick={() => {
                      handleViewCities(c.coverageCityNames);
                    }}
                    className="underline text-[#007AFF]"
                  >
                    View Cities
                  </button>
                ),
              },
              { label: "Date", render: (c) => formatDate(c.createdAt) },
              {
                label: "Status",
                render: (c: any) => (
                  <ToggleButton
                    onChange={() => handleToggleStatus(c)}
                    checked={c.status === "ACTIVE"}
                  />
                ),
              },
              {
                label: "Actions",
                render: (c: any) => (
                  <button
                    onClick={() => {
                      handleEyeAction(c);
                    }}
                    className="p-2 border rounded-full bg-[#F7F6F2]"
                  >
                    <IconEye />
                  </button>
                ),
              },
            ]}
          />
        </div>
      </div>

      {isModalOpen && (
        <AddTireModal
          selectedWarehouse={selectedWarehouseId}
          onClose={() => setIsModalOpen(false)}
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          clearErrors={clearErrors}
          control={control}
          handleSubmit={() => {
            handleSubmit(handleAddTire)();
          }}
          coverageCityError={coverageCityError}
          setCoverageCityError={setCoverageCityError}
          isPending={activePending}
          editable={editable}
          tireItem={tireItem}
          setTireItem={setTireItem}
        />
      )}
      <MessageModal
        open={actionModal}
        onClose={() => setActionModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={status === "ACTIVE" ? "/img/inactive.svg" : "/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={handleUpdateStatus}
        isPending={statusPending}
        size="md"
      />
      <ViewCitiesModal
        citiesItem={citiesArray ?? []}
        open={isOpen}
        onClose={closeModal}
      />
    </>
  );
}
